import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

import config from './config'

export const app = firebase.initializeApp(config.firebase)

export const functions = app.functions()

export const firestore = app.firestore()

export const storage = app.storage()

// Use the emulator on localhost
if (location.hostname === 'localhost') {
  const firebaseJson = require('../../../firebase.json')
  functions.useFunctionsEmulator(`http://localhost:${firebaseJson.emulators.functions.port}`)
  firestore.settings({
    host: `localhost:${firebaseJson.emulators.firestore.port}`,
    ssl: false
  })
}

/** Helper to automatically extract the `data` field from the response */
const extractData = fn => (...args) => fn(...args).then(({ data }) => data)

/** Helper to simplify disabling text and image templates */
const disable = fn => props => fn({ ...props, enabled: false })

/** Helper to simplify enabling text and image templates */
const enable = fn => props => fn({ ...props, enabled: true })

export const api = {
  helloWorld: extractData(functions.httpsCallable('helloWorld')),
  helloAuth: extractData(functions.httpsCallable('helloAuth')),
  events: {
    find: extractData(functions.httpsCallable('findEvents')),
    findById: extractData(functions.httpsCallable('findEventById')),
    sync: extractData(functions.httpsCallable('syncEvents')),
    findAdCountByEvent: extractData(functions.httpsCallable('findAdCountByEvent'))
  },
  eventOverrides: {
    create: extractData(functions.httpsCallable('createEventOverride')),
    find: extractData(functions.httpsCallable('findEventOverrides')),
    findById: extractData(functions.httpsCallable('findEventOverrideById')),
    findByEvent: extractData(functions.httpsCallable('findEventOverrideByEvent')),
    updateById: extractData(functions.httpsCallable('updateEventOverrideById'))
  },
  imageTemplates: {
    create: extractData(functions.httpsCallable('createImageTemplate')),
    disable: extractData(disable(functions.httpsCallable('enableImageTemplate'))),
    enable: extractData(enable(functions.httpsCallable('enableImageTemplate'))),
    find: extractData(functions.httpsCallable('findImageTemplates')),
    findById: extractData(functions.httpsCallable('findImageTemplateById')),
    render: extractData(functions.httpsCallable('renderImageTemplateWithEvent'))
  },
  textTemplates: {
    create: extractData(functions.httpsCallable('createTextTemplate')),
    disable: extractData(disable(functions.httpsCallable('enableTextTemplate'))),
    enable: extractData(enable(functions.httpsCallable('enableTextTemplate'))),
    find: extractData(functions.httpsCallable('findTextTemplates')),
    findById: extractData(functions.httpsCallable('findTextTemplateById')),
    render: extractData(functions.httpsCallable('renderTextTemplateWithEvent'))
  },
  campaigns: {
    create: extractData(functions.httpsCallable('createCampaign')),
    find: extractData(functions.httpsCallable('findCampaigns')),
    findById: extractData(functions.httpsCallable('findCampaignById'))
  },
  adSets: {
    create: extractData(functions.httpsCallable('createAdSet')),
    find: extractData(functions.httpsCallable('findAdSets')),
    findById: extractData(functions.httpsCallable('findAdSetById'))
  },
  adCreatives: {
    create: extractData(functions.httpsCallable('createAdCreative')),
    find: extractData(functions.httpsCallable('findAdCreatives')),
    findById: extractData(functions.httpsCallable('findAdCreativeById'))
  },
  ads: {
    create: extractData(functions.httpsCallable('createAd')),
    find: extractData(functions.httpsCallable('findAds')),
    findById: extractData(functions.httpsCallable('findAdById'))
  }
}
